/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EnvironVariablesCreate } from '../models';
// @ts-ignore
import type { EnvironVariablesOut } from '../models';
// @ts-ignore
import type { EnvironVariablesUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PaginatedEnvironVariablesOut } from '../models';
/**
 * EnvironVariablesApi - axios parameter creator
 * @export
 */
export const EnvironVariablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new variable by providing key-value data.
         * @param {EnvironVariablesCreate} environVariablesCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariable: async (environVariablesCreate: EnvironVariablesCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'environVariablesCreate' is not null or undefined
            assertParamExists('createVariable', 'environVariablesCreate', environVariablesCreate)
            const localVarPath = `/api/v1/environ-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(environVariablesCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a variable permanently by its ID.
         * @param {number} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariable: async (variableId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variableId' is not null or undefined
            assertParamExists('deleteVariable', 'variableId', variableId)
            const localVarPath = `/api/v1/environ-variables/{variable_id}`
                .replace(`{${"variable_id"}}`, encodeURIComponent(String(variableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve detailed information of a single variable by its ID.
         * @param {number} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariableDetail: async (variableId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variableId' is not null or undefined
            assertParamExists('getVariableDetail', 'variableId', variableId)
            const localVarPath = `/api/v1/environ-variables/{variable_id}`
                .replace(`{${"variable_id"}}`, encodeURIComponent(String(variableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a paginated list of variables with optional keyword filtering, sorting, and pagination support.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariables: async (agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/environ-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync variables with specific types (basic_auth, bearer_token) to all APIs of the agent.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncToApis: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('syncToApis', 'agentId', agentId)
            const localVarPath = `/api/v1/environ-variables/sync-to-apis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing variable\'s fields by its ID.
         * @param {number} variableId 
         * @param {EnvironVariablesUpdate} environVariablesUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariable: async (variableId: number, environVariablesUpdate: EnvironVariablesUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'variableId' is not null or undefined
            assertParamExists('updateVariable', 'variableId', variableId)
            // verify required parameter 'environVariablesUpdate' is not null or undefined
            assertParamExists('updateVariable', 'environVariablesUpdate', environVariablesUpdate)
            const localVarPath = `/api/v1/environ-variables/{variable_id}`
                .replace(`{${"variable_id"}}`, encodeURIComponent(String(variableId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(environVariablesUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnvironVariablesApi - functional programming interface
 * @export
 */
export const EnvironVariablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnvironVariablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new variable by providing key-value data.
         * @param {EnvironVariablesCreate} environVariablesCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVariable(environVariablesCreate: EnvironVariablesCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironVariablesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVariable(environVariablesCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.createVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a variable permanently by its ID.
         * @param {number} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVariable(variableId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVariable(variableId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.deleteVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve detailed information of a single variable by its ID.
         * @param {number} variableId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariableDetail(variableId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironVariablesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariableDetail(variableId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.getVariableDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a paginated list of variables with optional keyword filtering, sorting, and pagination support.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariables(agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEnvironVariablesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariables(agentId, page, pageSize, keyword, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.getVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync variables with specific types (basic_auth, bearer_token) to all APIs of the agent.
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncToApis(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncToApis(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.syncToApis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing variable\'s fields by its ID.
         * @param {number} variableId 
         * @param {EnvironVariablesUpdate} environVariablesUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVariable(variableId: number, environVariablesUpdate: EnvironVariablesUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnvironVariablesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVariable(variableId, environVariablesUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnvironVariablesApi.updateVariable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnvironVariablesApi - factory interface
 * @export
 */
export const EnvironVariablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnvironVariablesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new variable by providing key-value data.
         * @param {EnvironVariablesApiCreateVariableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariable(requestParameters: EnvironVariablesApiCreateVariableRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnvironVariablesOut> {
            return localVarFp.createVariable(requestParameters.environVariablesCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a variable permanently by its ID.
         * @param {EnvironVariablesApiDeleteVariableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariable(requestParameters: EnvironVariablesApiDeleteVariableRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteVariable(requestParameters.variableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve detailed information of a single variable by its ID.
         * @param {EnvironVariablesApiGetVariableDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariableDetail(requestParameters: EnvironVariablesApiGetVariableDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnvironVariablesOut> {
            return localVarFp.getVariableDetail(requestParameters.variableId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a paginated list of variables with optional keyword filtering, sorting, and pagination support.
         * @param {EnvironVariablesApiGetVariablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariables(requestParameters: EnvironVariablesApiGetVariablesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEnvironVariablesOut> {
            return localVarFp.getVariables(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync variables with specific types (basic_auth, bearer_token) to all APIs of the agent.
         * @param {EnvironVariablesApiSyncToApisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncToApis(requestParameters: EnvironVariablesApiSyncToApisRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.syncToApis(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing variable\'s fields by its ID.
         * @param {EnvironVariablesApiUpdateVariableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariable(requestParameters: EnvironVariablesApiUpdateVariableRequest, options?: RawAxiosRequestConfig): AxiosPromise<EnvironVariablesOut> {
            return localVarFp.updateVariable(requestParameters.variableId, requestParameters.environVariablesUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createVariable operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiCreateVariableRequest
 */
export interface EnvironVariablesApiCreateVariableRequest {
    /**
     * 
     * @type {EnvironVariablesCreate}
     * @memberof EnvironVariablesApiCreateVariable
     */
    readonly environVariablesCreate: EnvironVariablesCreate
}

/**
 * Request parameters for deleteVariable operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiDeleteVariableRequest
 */
export interface EnvironVariablesApiDeleteVariableRequest {
    /**
     * 
     * @type {number}
     * @memberof EnvironVariablesApiDeleteVariable
     */
    readonly variableId: number
}

/**
 * Request parameters for getVariableDetail operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiGetVariableDetailRequest
 */
export interface EnvironVariablesApiGetVariableDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof EnvironVariablesApiGetVariableDetail
     */
    readonly variableId: number
}

/**
 * Request parameters for getVariables operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiGetVariablesRequest
 */
export interface EnvironVariablesApiGetVariablesRequest {
    /**
     * 
     * @type {string}
     * @memberof EnvironVariablesApiGetVariables
     */
    readonly agentId?: string | null

    /**
     * 
     * @type {number}
     * @memberof EnvironVariablesApiGetVariables
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof EnvironVariablesApiGetVariables
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof EnvironVariablesApiGetVariables
     */
    readonly keyword?: string | null

    /**
     * 
     * @type {string}
     * @memberof EnvironVariablesApiGetVariables
     */
    readonly orderBy?: string
}

/**
 * Request parameters for syncToApis operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiSyncToApisRequest
 */
export interface EnvironVariablesApiSyncToApisRequest {
    /**
     * 
     * @type {string}
     * @memberof EnvironVariablesApiSyncToApis
     */
    readonly agentId: string
}

/**
 * Request parameters for updateVariable operation in EnvironVariablesApi.
 * @export
 * @interface EnvironVariablesApiUpdateVariableRequest
 */
export interface EnvironVariablesApiUpdateVariableRequest {
    /**
     * 
     * @type {number}
     * @memberof EnvironVariablesApiUpdateVariable
     */
    readonly variableId: number

    /**
     * 
     * @type {EnvironVariablesUpdate}
     * @memberof EnvironVariablesApiUpdateVariable
     */
    readonly environVariablesUpdate: EnvironVariablesUpdate
}

/**
 * EnvironVariablesApi - object-oriented interface
 * @export
 * @class EnvironVariablesApi
 * @extends {BaseAPI}
 */
export class EnvironVariablesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new variable by providing key-value data.
     * @param {EnvironVariablesApiCreateVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public createVariable(requestParameters: EnvironVariablesApiCreateVariableRequest, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).createVariable(requestParameters.environVariablesCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a variable permanently by its ID.
     * @param {EnvironVariablesApiDeleteVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public deleteVariable(requestParameters: EnvironVariablesApiDeleteVariableRequest, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).deleteVariable(requestParameters.variableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve detailed information of a single variable by its ID.
     * @param {EnvironVariablesApiGetVariableDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public getVariableDetail(requestParameters: EnvironVariablesApiGetVariableDetailRequest, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).getVariableDetail(requestParameters.variableId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a paginated list of variables with optional keyword filtering, sorting, and pagination support.
     * @param {EnvironVariablesApiGetVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public getVariables(requestParameters: EnvironVariablesApiGetVariablesRequest = {}, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).getVariables(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync variables with specific types (basic_auth, bearer_token) to all APIs of the agent.
     * @param {EnvironVariablesApiSyncToApisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public syncToApis(requestParameters: EnvironVariablesApiSyncToApisRequest, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).syncToApis(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing variable\'s fields by its ID.
     * @param {EnvironVariablesApiUpdateVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnvironVariablesApi
     */
    public updateVariable(requestParameters: EnvironVariablesApiUpdateVariableRequest, options?: RawAxiosRequestConfig) {
        return EnvironVariablesApiFp(this.configuration).updateVariable(requestParameters.variableId, requestParameters.environVariablesUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

